import styled from "styled-components";
import { useEffect, useContext } from "react";
import { scroller, animateScroll } from "react-scroll";
import { LanguageContext } from "../../components/LanguageContext";

const Footer = () => {
  const { language } = useContext(LanguageContext);
  return (
    <StyledFooter>
      <Copyright>Sabien Prissette</Copyright>
    </StyledFooter>
  );
};

const StyledFooter = styled.footer`
  background: white;
  height: 8vh;
  align-items: center;
  justify-content: center;
  display: flex;
`;
const Copyright = styled.h5`
  width: fit-content;
  font-size: 1.1rem;
  ::before {
    content: "© ";
    width: inherit;
    height: inherit;
  }
`;

export default Footer;
